// extracted by mini-css-extract-plugin
module.exports = {"buttonDock":"style-module__buttonDock___2jvvl","confirmationModal":"style-module__confirmationModal___3wk1j"};